import api from './axiosApi'
import type { PaginatedPlansResponse, ApiPlanDetailResponse } from '@/types'

// --- API functions ---

interface ListDeletedPlansParams {
  search?: string
  plan_type?: string
  deleted_after?: string
  deleted_before?: string
  sort?: string
  offset?: number
  limit?: number
}

export async function fetchDeletedPlans(
  params: ListDeletedPlansParams = {}
): Promise<PaginatedPlansResponse> {
  const {
    search,
    plan_type,
    deleted_after,
    deleted_before,
    sort = '-deleted_at',
    offset = 0,
    limit = 20,
  } = params

  const response = await api.get<PaginatedPlansResponse>('/plans/deleted', {
    params: {
      q: search || undefined,
      plan_type: plan_type || undefined,
      deleted_after: deleted_after || undefined,
      deleted_before: deleted_before || undefined,
      sort,
      offset,
      limit,
    },
  })

  return response.data
}

export async function restorePlan(
  planId: string
): Promise<ApiPlanDetailResponse> {
  const response = await api.post<ApiPlanDetailResponse>(
    `/plans/${planId}/restore`
  )
  return response.data
}
